import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, getCurrentUser, clearAuth } from '../../lib/auth.ts';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;

  // Reject expired tokens — clear stale auth state so the login page is clean.
  const user = getCurrentUser();
  if (user?.exp && user.exp * 1000 < Date.now()) {
    clearAuth();
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
